import { createSelector } from 'reselect';
import { get } from 'lodash';

const selectProject = state => state.modals.Order.project;

export default createSelector(
  selectProject,
  (project) => get(project, 'client_site.client.client_contacts', [])
)
